module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-mobile-04-68d8422d15561e9a3b0dc22680d9e28d.jpg";